import { render, staticRenderFns } from "./Tukang_Order.vue?vue&type=template&id=a3462152&scoped=true&"
import script from "./Tukang_Order.vue?vue&type=script&lang=js&"
export * from "./Tukang_Order.vue?vue&type=script&lang=js&"
import style0 from "./Tukang_Order.vue?vue&type=style&index=0&id=a3462152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3462152",
  null
  
)

export default component.exports